@if (isloading) {
  <div></div>
}
@if (startSeiteHtmlContent) {
  <div>
    <br />
    <div [innerHTML]="startSeiteHtmlContent"></div>
  </div>
}
@if (!startSeiteHtmlContent && !isloading) {
  <div class="col-md-8 mt-md-5">
    <h2 class="title-divider">{{ "dashboard.rechtehinweis.legalHintHeader" | translate }}</h2>
    <p>{{ "dashboard.rechtehinweis.legalHintMessage" | translate }}</p>
    <p>{{ "dashboard.rechtehinweis.legalHintComment" | translate }}</p>
    <p>{{ "dashboard.rechtehinweis.legalHintComment1" | translate }}</p>
  </div>
}
